import { render, staticRenderFns } from "./children.vue?vue&type=template&id=b549c398&scoped=true&"
import script from "./children.vue?vue&type=script&lang=js&"
export * from "./children.vue?vue&type=script&lang=js&"
import style0 from "./children.vue?vue&type=style&index=0&id=b549c398&lang=scss&scoped=true&"
import style1 from "./children.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b549c398",
  null
  
)

export default component.exports